(() => {
  function initialise(root) {
    const form = root.querySelector('form');
    if (!form || form.dataset.tailoredReady || root.querySelector('.m-success')) return;
    form.dataset.tailoredReady = 'true';
    const steps = [...form.querySelectorAll('[data-step]')];
    const indicators = [...form.querySelectorAll('.m-steps li')];
    const back = form.querySelector('[data-step-back]');
    const next = form.querySelector('[data-step-next]');
    const submit = form.querySelector('[data-step-submit]');
    const status = form.querySelector('[data-step-status]');
    let current = 0;
    let unit = 'cm';
    let sending = false;
    root.classList.add('m-enhanced');
    form.noValidate = true;
    const reference = `EBT-${new Date().toISOString().slice(0,10).replaceAll('-','')}-${crypto.getRandomValues(new Uint32Array(1))[0].toString(36).slice(0,6).toUpperCase()}`;
    form.querySelector('[data-brief-reference]').value = reference;
    const date = form.querySelector('[data-future-date]');
    const localDate = new Date();
    if (date) date.min = `${localDate.getFullYear()}-${String(localDate.getMonth()+1).padStart(2,'0')}-${String(localDate.getDate()).padStart(2,'0')}`;
    function valuesFor(step) {
      const rows = [];
      step.querySelectorAll('input,select,textarea').forEach(input => {
        if (!input.name?.startsWith('contact[') || input.type === 'hidden' || input.type === 'checkbox' || (input.type === 'radio' && !input.checked)) return;
        const value = input.value.trim();
        if (value) rows.push([input.name.slice(8,-1), value + (input.matches('[data-measure]') ? ` ${unit}` : '')]);
      });
      return rows;
    }
    function briefText() {
      const sections = steps.slice(0,5).map((step,index) => `${String(index+1).padStart(2,'0')} / ${indicators[index].textContent.trim().replace(/^\d+\s*/, '')}\n${valuesFor(step).map(([key,value])=>`${key}: ${value}`).join('\n')}`);
      return `ETHAN BING TAILORED\nPRIVATE COMMISSION BRIEF\nReference: ${reference}\n\n${sections.join('\n\n')}\n\nConsent: ${form.querySelector('[name="contact[Consent]"]').checked ? 'Confirmed for tailoring enquiry and fitting arrangements.' : 'Not yet confirmed.'}\n\nThis is an enquiry. Measurements, cloth, pricing and fitting arrangements require confirmation by the tailor.`;
    }
    function review() {
      const target = form.querySelector('[data-brief-review]');
      target.replaceChildren();
      steps.slice(0,5).forEach((step,index) => {
        const group = document.createElement('section');group.className = 'm-review-group';
        const edit = document.createElement('button');edit.type='button';edit.className='m-review-edit';edit.textContent='Edit';edit.setAttribute('aria-label',`Edit ${indicators[index].textContent.trim()}`);edit.onclick=()=>show(index,true);
        const heading = document.createElement('h3');heading.textContent=indicators[index].textContent.trim().replace(/^\d+\s*/,'');
        const list = document.createElement('dl');
        valuesFor(step).forEach(([key,value])=>{const dt=document.createElement('dt');dt.textContent=key;const dd=document.createElement('dd');dd.textContent=value;list.append(dt,dd);});
        group.append(edit,heading,list);target.append(group);
      });
      form.querySelector('[data-brief-body]').value = briefText();
    }
    function show(index, focus=false) {
      current = Math.min(steps.length-1,Math.max(0,index));
      steps.forEach((step,i)=>step.hidden=i!==current);
      indicators.forEach((item,i)=>{item.classList.toggle('is-active',i===current);item.classList.toggle('is-complete',i<current);if(i===current)item.setAttribute('aria-current','step');else item.removeAttribute('aria-current');});
      back.hidden=current===0;next.hidden=current===steps.length-1;submit.hidden=current!==steps.length-1;
      form.querySelector('[data-step-count]').textContent=`0${current+1} / 06`;
      status.textContent='';
      if(current===5)review();
      if(focus){const legend=steps[current].querySelector('legend');legend.tabIndex=-1;legend.focus({preventScroll:true});steps[current].scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});}
    }
    function invalidIn(step) {
      const phone=form.querySelector('[name="contact[phone]"]');
      const preference=form.querySelector('[name="contact[Preferred contact]"]');
      if (step.contains(preference)) phone.required=preference.value==='Telephone';
      return [...step.querySelectorAll('input,select,textarea')].find(input=>!input.checkValidity());
    }
    function validateStep(index) {
      const invalid=invalidIn(steps[index]);
      if(!invalid)return true;
      show(index);status.textContent='Please check the highlighted field before continuing.';invalid.focus();invalid.reportValidity();return false;
    }
    next.addEventListener('click',()=>{if(validateStep(current))show(current+1,true);});
    back.addEventListener('click',()=>show(current-1,true));
    form.querySelectorAll('[data-measure]').forEach(input => input.addEventListener('input', () => {
      if(input.value==='') delete input.dataset.cmValue;
      else input.dataset.cmValue=String(Number(input.value)*(unit==='cm'?1:2.54));
    }));
    form.querySelectorAll('[data-unit]').forEach(radio=>radio.addEventListener('change',()=>{
      if(!radio.checked || radio.value===unit)return;
      const nextUnit=radio.value;
      form.querySelectorAll('[data-measure]').forEach(input=>{
        if(input.value!=='' && Number.isFinite(Number(input.value))){const cm=input.dataset.cmValue!==undefined?Number(input.dataset.cmValue):(unit==='cm'?Number(input.value):Number(input.value)*2.54);input.dataset.cmValue=String(cm);input.value=(nextUnit==='cm'?cm:cm/2.54).toFixed(1);}
        const factor=nextUnit==='cm'?1:2.54;input.min=(Number(input.dataset.minCm)/factor).toFixed(1);input.max=(Number(input.dataset.maxCm)/factor).toFixed(1);
      });
      unit=nextUnit;form.querySelectorAll('.m-unit').forEach(label=>label.textContent=unit);
      form.querySelector('[data-unit-notice]').textContent=`All dimensions are in ${unit==='cm'?'centimetres':'inches'}. Existing measurements have been converted.`;
    }));
    const download = () => {
      const url=URL.createObjectURL(new Blob([briefText()],{type:'text/plain;charset=utf-8'}));
      const a=document.createElement('a');a.href=url;a.download=`${reference}-Tailoring-Brief.txt`;document.body.append(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);
    };
    form.querySelector('[data-download-brief]').addEventListener('click',download);
    form.addEventListener('submit',event=>{
      if(sending){event.preventDefault();return;}
      if(current<5){event.preventDefault();if(validateStep(current))show(current+1,true);return;}
      for(let i=0;i<steps.length;i++){if(!validateStep(i)){event.preventDefault();return;}}
      form.querySelector('[data-brief-body]').value=briefText();
      if(document.documentElement.dataset.preview==='true'){
        event.preventDefault();status.textContent='Preview only — no request has been sent. The Shopify theme submits this complete brief to the store’s customer-service email. You can download your brief below.';
        status.scrollIntoView({block:'center',behavior:'smooth'});return;
      }
      sending=true;submit.disabled=true;submit.textContent='Sending your brief…';
      setTimeout(()=>{sending=false;submit.disabled=false;submit.textContent='Send to Client Services';},15000);
    });
    window.addEventListener('pageshow',()=>{sending=false;submit.disabled=false;});
    show(0);
    if(form.querySelector('[data-server-errors]')) status.textContent='Shopify could not accept the previous submission. Please review your details and try again.';
  }
  document.querySelectorAll('[data-tailored]').forEach(initialise);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-tailored]').forEach(initialise));
})();
